//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const AvailableSlotsForAppointment = createAsyncThunk(
  "AvailableSlotsForAppointment",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingAvailableSlotsForAppointment(""));
      const response = await UsePortalApi(
        `Patient/AvailableSlotsForAppointment`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
         dispatch(gettingAvailableSlotsForAppointmentSuccess(response))

      } else {
        dispatch(
          gettingAvailableSlotsForAppointmentFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingAvailableSlotsForAppointmentFailed(error));
    }
  }
);
const AvailableSlotsForAppointmentSlice = createSlice({
  name: "AvailableSlotsForAppointment",
  initialState: {
    AvailableSlotsForAppointmentData: null,
    isAvailableSlotsForAppointmentData: false,
    isAvailableSlotsForAppointmentError: false,
  },
  reducers: {
    gettingAvailableSlotsForAppointment: (state, action) => {
      state.AvailableSlotsForAppointmentData = null;
      state.isAvailableSlotsForAppointmentData = true;
      state.isAvailableSlotsForAppointmentError = false;
    },
    gettingAvailableSlotsForAppointmentSuccess: (state, action) => {
      state.AvailableSlotsForAppointmentData = action.payload;
      state.isAvailableSlotsForAppointmentData = false;
      state.isAvailableSlotsForAppointmentError = false;
    },
    gettingAvailableSlotsForAppointmentFailed: (state, action) => {
      state.AvailableSlotsForAppointmentData = null;
      state.isAvailableSlotsForAppointmentData = false;
      state.isAvailableSlotsForAppointmentError = true;
    },
    gettingAvailableSlotsForAppointmentClear: (state, action) => {
      state.AvailableSlotsForAppointmentData = null;
      state.isAvailableSlotsForAppointmentData = false;
      state.isAvailableSlotsForAppointmentError = false;
    },
  },
});
export const {
  gettingAvailableSlotsForAppointment,
  gettingAvailableSlotsForAppointmentSuccess,
  gettingAvailableSlotsForAppointmentFailed,
  gettingAvailableSlotsForAppointmentClear,
} = AvailableSlotsForAppointmentSlice.actions;
export default AvailableSlotsForAppointmentSlice.reducer;
